import { Injectable } from '@angular/core';
import { Attachment } from '../reservation/reservation.model';

export interface FileObject {
	base64Url: string;
	mimeType: string;
	filename: string;
}

@Injectable({
	providedIn: 'root',
})
export class DownloadFileService {
	downloadAttachment(value: Attachment) {
		const attachment: FileObject = {
			base64Url: value.src.split(',')[1],
			filename: value.filename,
			mimeType: value.mimeType,
		};
		this.downloadFile(attachment);
	}
	downloadFile(value: FileObject): void {
		const byteString = atob(value.base64Url);
		const intArray = new Uint8Array(byteString.length).map((_, i) => byteString.charCodeAt(i));

		const blob = new Blob([intArray], { type: value.mimeType });
		const url = URL.createObjectURL(blob);

		const a = document.createElement('a');
		a.href = url;
		a.download = value.filename;
		a.click();

		return URL.revokeObjectURL(url);
	}

	downloadBlob(blob: Blob, filename: string): void {
		const url = window.URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = filename;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
		window.URL.revokeObjectURL(url);
	}
}
